import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import styles from "./AddStripeConfirmation.module.scss";
import Button from '../../Button/Button';
import ThankyouStripeModal from '../ThankyouStripeModal/ThankyouStripeModal';

const AddStripeConfirmation = ({ show, handleBack, handleClose }) => {
    const [showThanks, setShowThanks] = useState(false);
    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                title="Add Stripe Account"
                className={styles.add_stripe}
            >
                <h5>“STBL” wants to use “stripe.com” to Sign in</h5>
                <p>This shares your Stripe details with STBL.</p>
                <div className={styles.action}>
                    <Button
                        variant="bordered_grey"
                        fluid
                        onClick={handleBack}
                    >No, Go Back</Button>
                    <Button fluid
                        onClick={() => { handleClose(); setShowThanks(true) }}
                    >Continue</Button>
                </div>
            </Modal>
            <ThankyouStripeModal
                show={showThanks}
                handleClose={() => setShowThanks(false)}
            />
        </>
    )
}

export default AddStripeConfirmation;